

import { Dropdown, Field, Option } from "@fluentui/react-components";
import { emailItemsSelectionOptions, EMailSettingKey } from "../../../../utilities/ConfigurationData/Mail/Mail";
import { EDMSNextSettingKey, fileOpenPreference } from "../../../../utilities/ConfigurationData/DMSNext/DMSNext";

export interface INumberInputProps {
    settingKey: string;
    value: number
    label: string;
    onValueChange(value: number): void;
    onIsValidChange(isValid: boolean): void;
}

export const NumberInput = (props: INumberInputProps) => {
    const { settingKey, label, value, onValueChange, onIsValidChange } = props;

    const onOptionSelected = (selectedValue?: string) => {
        if (!selectedValue) {
            return;
        }
        const num = Number(selectedValue);
        if (!isNaN(num)) {
            onValueChange(num);
            onIsValidChange(true);
        }
    };

    const renderDropdown = (options: { key: number; text: string }[]) => (
        <Field label={label}>
        <Dropdown onOptionSelect={(_, data) => onOptionSelected(data.optionValue)} defaultValue={options[value].text} defaultSelectedOptions={[String(value)]}>
            {options.map((option) => (
                <Option key={option.key} text={option.text} value={String(option.key)}>
                    {option.text}
                </Option>
            ))}
        </Dropdown>
        </Field>
    );

    if (settingKey === EMailSettingKey.defaultItemSelection) {
        return renderDropdown(emailItemsSelectionOptions);
    }

    if (settingKey === EDMSNextSettingKey.fileOpenPreference) {
        return renderDropdown(fileOpenPreference);
    }

    return null;
};